import $ from 'jquery';

const selectors = {
    elem: '.accordion',
    option: '.accordion__option',
    section: '.accordion__section'
};

const states = {
    activeOption: 'accordion__option--active',
    activeSection: 'accordion__section--active'
};

const onOptionClick = function (evt) {
    evt.preventDefault();

    const $this = $(evt.currentTarget);

    const $targetSection = $($this.attr('href'));

    $this.toggleClass(states.activeOption);

    $targetSection.slideToggle({
        complete() {
            $(this).toggleClass(states.activeSection)
                .removeAttr('style');
        }
    });
};

export default {
    init() {
        const $Accordion = $(selectors.elem);

        if (!$Accordion.length) {
            return;
        }

        $Accordion.each((key, item) => {
            let $item = $(item);
            if ($item.hasClass('not-inited')) {
                $item.on('click', selectors.option, onOptionClick);
                $item.removeClass('not-inited');
            }
        });
    }
};
